import { render, staticRenderFns } from "./AppNavbarVerticalLayout.vue?vue&type=template&id=0af4295c&"
import script from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=0&id=0af4295c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports